import { createAction, createApiAction } from '@saucelabs/sl-util-redux';

export const createTestListActions = (types, api) => ({
  setTestCaseQueryType: createAction(types.SET_TEST_CASE_QUERY),
  changePage: createAction(types.CHANGE_PAGE),
  changeSize: createAction(types.CHANGE_SIZE),
  resetPage: createAction(types.RESET_PAGE),
  cleanup: createAction(types.CLEANUP),
  changeSorting: createAction(types.CHANGE_SORTING),
  changeTrendsInterval: createAction(types.CHANGE_TRENDS_INTERVAL),
  changeSelectedBar: createAction(types.CHANGE_SELECTED_BAR),
  getTestCases: createApiAction(
    types.GET_TEST_CASES,
    (params) => api.getTestCases(params),
    { meta: { skipErrorPage: true } },
  ),
  getTestCasesCSV: createApiAction(
    types.GET_TEST_CASES_CSV,
    (params) => api.getTestCasesCSV(params),
    { meta: { skipErrorPage: true } },
  ),
  getTestCasesTrends: createApiAction(
    types.GET_TEST_CASES_TRENDS,
    (params) => api.getTestCasesTrends(params),
    { meta: { skipErrorPage: true } },
  ),
});
